/**
 * Created by hj on 2017/8/15.
 */
import React from 'react';
import {hashHistory} from 'react-router';
import {Form, Input, Select, Button, Row, Col} from 'antd';
import {DmsTab, SelectRange} from 'Components';

const FormItem = Form.Item;
import {openNotice, APIS, config, showSpin, hideSpin} from 'Utils';
import {
    getDetails,
    add
} from '../../service/product';

const {TextArea} = Input;

class ProductCustomerAdd extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            opts: [],
            btnLoad: false,
            detail: {},
        }
    }

    cancelHandle() {
        hashHistory.goBack()
    }

    submitHandle() {
        let productId = this.props.params.productId;
        let self = this;
        self.setState({
            'btnLoad': true
        });
        const {validateFields, getFieldsValue} = self.props.form;
        validateFields((errors) => {//表单校验
            if (errors) {
                self.setState({
                    'btnLoad': false
                });
                return
            }//表单校验有误，则不执行下面的代码
            const saveData = {
                ...getFieldsValue() //获取用户输入
            };
            showSpin();
            if (productId) {
                /* 编辑 */
                saveData.id = productId;
                add(saveData).then(function (result) {
                    hideSpin();
                    self.setState({
                        'btnLoad': false
                    });
                    if (result && result.code == 200 && result.data) {
                        openNotice('success', '保存成功', '');
                        window.history.go(-1);
                    } else {
                        openNotice('error', '保存失败', (result && result.message) ? result.message : '');
                    }
                });
            } else {
                add(saveData).then(function (result) {
                    hideSpin();
                    self.setState({
                        'btnLoad': false
                    });
                    if (result && result.code == 200 && result.data) {
                        openNotice('success', '保存成功', '');
                        window.history.go(-1);
                    } else {
                        openNotice('error', '保存失败', (result && result.message) ? result.message : '');
                    }
                });
            }
        })
    }

    componentDidMount() {
        let productId = this.props.params.productId;
        getDetails({id: productId}).then(res => {
            if (res.code === 200) {
                this.setState({
                    detail: res.data || {}
                });
            }
        });
    }

    render() {
        let self = this;
        const {btnLoad, detail} = this.state;
        const {getFieldDecorator} = this.props.form;
        return <div className="dms-body">
            <DmsTab options={self.state.opts} defaultKey={0}>
                <Button onClick={this.cancelHandle.bind(this)}>取消</Button>
                <Button type='primary' loading={btnLoad} onClick={this.submitHandle.bind(this)}>保存</Button>
            </DmsTab>

            <div style={{padding: '12px', background: '#fff'}}>
                <Form layout="horizontal">
                    <Row gutter={16}>
                        <Col className="gutter-row" span={12}>
                            <FormItem label="子库存编码：" hasFeedback>
                                {getFieldDecorator('subStoreNumber', {
                                    initialValue: detail.subStoreNumber ? detail.subStoreNumber : '',
                                    rules: [
                                        {
                                            required: true,
                                            message: '请输入子库存编码'
                                        },
                                    ],
                                })(<Input placeholder="请输入子库存编码"/>)}
                            </FormItem>
                        </Col>
                        <Col className="gutter-row" span={12}>
                            <FormItem label="子库存名称：" hasFeedback>
                                {getFieldDecorator('subStoreName', {
                                    initialValue: detail.subStoreName ? detail.subStoreName : '',
                                    rules: [
                                        {
                                            required: true,
                                            message: '请输入子库存名称'
                                        },
                                    ],
                                })(<Input placeholder="请输入子库存名称"/>)}
                            </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="gutter-row">
                            <FormItem label="说明：">
                                {getFieldDecorator('sutStoreText', {
                                    initialValue: detail.sutStoreText ? detail.sutStoreText : '',
                                    rules: [
                                        {
                                            required: false,
                                            message: ''
                                        },
                                    ],
                                })(<TextArea rows={3}/>)}
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col className="gutter-row" span={12}>
                            <FormItem label="主库存">
                                {getFieldDecorator('masterStore', {
                                    initialValue: detail.masterStore ? detail.masterStore : '',
                                    rules: [
                                        {
                                            required: true,
                                            message: '请选择是否主库存'
                                        },
                                    ]
                                })(<Select>
                                    <Select.Option value='Y'>是</Select.Option>
                                    <Select.Option value='N'>否</Select.Option>
                                </Select>)}
                            </FormItem>
                        </Col>
                        <Col className="gutter-row" span={12}>
                            <FormItem label="有效性">
                                {getFieldDecorator('takeEffect', {
                                    initialValue: detail.takeEffect ? detail.takeEffect : '',
                                    rules: [
                                        {
                                            required: true,
                                            message: '请选择是否生效'
                                        },
                                    ]
                                })(<Select>
                                    <Select.Option value='Y'>是</Select.Option>
                                    <Select.Option value='N'>否</Select.Option>
                                </Select>)}
                            </FormItem>
                        </Col>
                    </Row>
                </Form>
            </div>
        </div>
    }
}

export default Form.create()(ProductCustomerAdd)


// WEBPACK FOOTER //
// ./src/routes/subStock/add.js